/** Keys must match backend GET /sponsored-ads/feed-ad-placements */
export const FEED_PLACEMENT_KEYS = [
  'home_feed',
  'explore_feed',
  'reels',
  'match_wall'
];

export const FEED_PLACEMENT_LABELS = {
  home_feed: 'Home feed (competition)',
  explore_feed: 'Explore feed (global)',
  reels: 'Reels (vertical)',
  match_wall: 'Match wall feed'
};

/** Server-side max ads per page — for admin reference / validation hints */
export const FEED_PLACEMENT_MAX_ADS = {
  home_feed: 2,
  explore_feed: 3,
  reels: 1,
  match_wall: 2
};

export function formatPlacementList(placements) {
  if (!Array.isArray(placements) || placements.length === 0) return 'All';
  return placements
    .map((key) => FEED_PLACEMENT_LABELS[key] || key)
    .join(', ');
}

export function togglePlacement(selected, key) {
  const set = new Set(selected || []);
  if (set.has(key)) set.delete(key);
  else set.add(key);
  return [...set];
}
